import { useField } from "formik";
import { TextField as Input } from "@mui/material";

export function TextField({ width, style, ...props }: any) {
  const [field] = useField(props);

  return <Input hiddenLabel={true} {...field} style={{ width, ...style }} {...props} />;
}
